/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanySearchAddress
 */
export interface CompanySearchAddress {
    /**
     * 
     * @type {string}
     * @memberof CompanySearchAddress
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchAddress
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchAddress
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchAddress
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchAddress
     */
    formattedAddress: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchAddress
     */
    region?: string;
}

/**
 * Check if a given object implements the CompanySearchAddress interface.
 */
export function instanceOfCompanySearchAddress(value: object): value is CompanySearchAddress {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('formattedAddress' in value) || value['formattedAddress'] === undefined) return false;
    return true;
}

export function CompanySearchAddressFromJSON(json: any): CompanySearchAddress {
    return CompanySearchAddressFromJSONTyped(json, false);
}

export function CompanySearchAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySearchAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'] == null ? undefined : json['street'],
        'street2': json['street2'] == null ? undefined : json['street2'],
        'city': json['city'] == null ? undefined : json['city'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'countryCode': json['countryCode'],
        'formattedAddress': json['formattedAddress'],
        'region': json['region'] == null ? undefined : json['region'],
    };
}

export function CompanySearchAddressToJSON(value?: CompanySearchAddress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'street': value['street'],
        'street2': value['street2'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'countryCode': value['countryCode'],
        'formattedAddress': value['formattedAddress'],
        'region': value['region'],
    };
}

